import { useState } from "react";
import { useSelector } from "react-redux";
import { useTranslation, Trans } from "react-i18next";
import { Dialog } from "@headlessui/react";
import DialogBackdrop from "./DialogBackdrop";
import DeletePaymentProfile from "service/paymentServices/DeletePaymentProfile";
import GeneralPurposeDialog from "components/General/GeneralPurposeDialog";

const DeleteCCPaymentModal = ({
  modalState,
  setModalState,
  data,
  selectedPolicies,
  isUpdated,
  setIsUpdated,
  setToastDetail,
}) => {
  const { t } = useTranslation();
  const { user } = useSelector((state) => state.user);
  const { csrUser } = useSelector((s) => s.csrUser);
  const [csrUserState, setCsrUserState] = useState(false);

  async function onSubmit() {
    if (csrUser?.userId) {
      setCsrUserState(true);
      setModalState(false);
      return;
    }
    const { contractID, blockCode, bankInfo } =
      selectedPolicies?.length > 0 ? selectedPolicies[0] : [];
    const payload = {
      paymentProfileId: data?.paymentProfileId,
      policyId: contractID,
      blockCode: blockCode,
      userid: user?.userId,
      draftDay: bankInfo?.draftDay,
    };
    setToastDetail({
      type: undefined,
    });
    if (payload) {
      //delete Payment Profile
      await DeletePaymentProfile(payload)
        .then(() => {
          setIsUpdated(!isUpdated);
          setToastDetail({
            type: "success",
            title: t("CreditCardDeleteAutoPayModal-deleteSuccessTitle", {
              card: `[${data?.cardType} xxxx ${data?.accountNumber?.substring(
                data?.accountNumber.length - 4
              )}]`,
            }),
            message: t("CreditCardDeleteAutoPayModal-deleteSuccessDesc"),
          });
          setModalState(false);
        })
        .catch((error) => {
          setIsUpdated(!isUpdated);
          console.error(
            "Server refused to connect, please try again later.",
            error
          );
          setToastDetail({
            type: "error",
            title: t("CreditCardDeleteAutoPayModal-deleteFailureTitle"),
            message: t("CreditCardDeleteAutoPayModal-deleteFailureDesc"),
          });
          setModalState(false);
        });
    } else {
      setIsUpdated(!isUpdated);
      setToastDetail({
        type: "error",
        title: t("CreditCardDeleteAutoPayModal-deleteFailureTitle"),
        message: t("CreditCardDeleteAutoPayModal-deleteFailureDesc"),
      });
      setModalState(false);
    }
  }

  return (
    <>
      <Dialog
        role="dialog"
        aria-modal="true"
        className="fixed inset-0 top-[20%] z-20 overflow-y-auto"
        open={modalState}
        onClose={() => setModalState(false)}
      >
        <DialogBackdrop />
        <Dialog.Panel className="ui-default-dialog md:max-w-xl">
          <Dialog.Title className="font-body text-xl font-bold text-left">
            {t("CreditCardDeleteAutoPayModal-title")}
          </Dialog.Title>
          <button
            className="ui-default-dialog-close"
            onClick={() => setModalState(false)}
          >
            <svg
              className="ui-icon h-3.5 w-3.5"
              focusable="false"
              aria-hidden="true"
              role="presentation"
            >
              <use href="#ui-icon-close"></use>
            </svg>
          </button>
          <hr />

          <Dialog.Description as="div">
            <p>
              <Trans
                i18nKey="CreditCardDeleteAutoPayModal-desc"
                values={{
                  policy: selectedPolicies[0]?.oldPolicy,
                  card: `[${
                    data?.cardType
                  } xxxx ${data?.accountNumber?.substring(
                    data?.accountNumber.length - 4
                  )}]`,
                }}
              ></Trans>
            </p>
          </Dialog.Description>
          <div className="block text-right mt-6">
            <button
              className="ui-btn-secondary ui-btn-min-w mt-4"
              onClick={() => setModalState(false)}
            >
              {t("CreditCardDeleteAutoPayModal-buttonCancel")}
              <span className="sr-only">
                {t("CreditCardDeleteAutoPayModal-buttonSrText")}
              </span>
            </button>
            <button
              className="ui-btn-primary ui-btn-min-w mt-4"
              onClick={() => onSubmit()}
            >
              {t("CreditCardDeleteAutoPayModal-buttonYes")}
              <span className="sr-only">
                {t("CreditCardDeleteAutoPayModal-buttonSrText")}
              </span>
            </button>
          </div>
        </Dialog.Panel>
      </Dialog>
      <GeneralPurposeDialog
        title={t("CSRErrorMessage-title")}
        desc={t("CSRErrorMessage-message")}
        state={csrUserState}
        setState={setCsrUserState}
        showCloseButton={false}
      />
    </>
  );
};

export default DeleteCCPaymentModal;
